import apiClient from '@/services/axios'

export async function del(venueSetupId, venueSectionId, tableId) {

  var response = await apiClient.delete(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/venue-setups/' + venueSetupId + '/venue-sections/' + venueSectionId + '/venue-tables/' + tableId, { data: { foo: "bar" } });

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to delete table: Bookings are reserved for this table...');
}
